import Axios from "axios";

const baseURL = process.env.BARRAMUNDI;

export default {
    getCubexSetting() {
        return Axios.get(
            `${baseURL}account/add-on/get-credentials?code=CUBEX`
        ).then(response => response.data.response);
    },
    updateCubexSetting({
        businessId = "",
        databaseName = "",
        databaseUser = "",
        databasePassword = "",
        subscriptionKey = ""
    }) {
        return Axios.post(`${baseURL}account/add-on/manage`, {
            code: "CUBEX",
            business_id: businessId,
            database_name: databaseName,
            database_user: databaseUser,
            database_password: databasePassword,
            subscription_key: subscriptionKey
        }).then(response => response.data.response);
    },
    enableCubex({
        businessId = "",
        databaseName = "",
        databaseUser = "",
        databasePassword = "",
        subscriptionKey = ""
    }) {
        return Axios.put(`${baseURL}account/add-on/enable`, {
            source: "CUBEX",
            business_id: businessId,
            database_name: databaseName,
            database_user: databaseUser,
            database_password: databasePassword,
            subscription_key: subscriptionKey
        }).then(response => response.data.response);
    },
    disableCubex({ businessId }) {
        return Axios.put(`${baseURL}account/add-on/disable`, {
            code: "CUBEX",
            business_id: businessId
        }).then(response => response.data.response);
    },
    getUsers({ businessId, search = "" }) {
        return Axios.post(`${baseURL}inventory/cubex/list/staff`, {
            business_id: businessId,
            search: search
        }).then(response => response.data.response);
    },
    exportUsers(userIds) {
        return Axios.post(`${baseURL}inventory/cubex/export/staff`, {
            staff_ids: userIds
        }).then(response => response.data.response);
    },
    getItems(params) {
        return Axios.post(`${baseURL}inventory/cubex/list/item`, params).then(
            response => response.data.response
        );
    },
    exportItems(itemIds) {
        return Axios.post(`${baseURL}inventory/cubex/export/item`, {
            item_ids: itemIds
        }).then(response => response.data.response);
    },
    syncItems(businessId) {
        return Axios.post(`${baseURL}inventory/cubex/sync/item`, {
            business_id: businessId
        }).then(response => response.data.response);
    },
    getPendingCubexItem(invoiceId) {
        return Axios.get(
            `${baseURL}inventory/cubex/invoice/pending-items/${invoiceId}`
        ).then(response => response.data.response);
    }
};
